import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowUpOutlined, RocketOutlined } from "@ant-design/icons";
import { Button, theme } from "antd";
import { COLOR_PRIMARY_DEEP } from "../../../../../../style/antdTheme.js";
import { __ } from "../../../../../../utils/i18n.js";
const LicenseAllocationUpgradePromo = ({ productName, exhaustedPools, onUpgradeClick })=>{
    const { token } = theme.useToken();
    if (exhaustedPools.length === 0) {
        return null;
    }
    let headline;
    if (exhaustedPools.length === 2) {
        headline = __("All %s licenses are allocated", productName);
    } else if (exhaustedPools[0] === "production") {
        headline = __("All %s production licenses are allocated", productName);
    } else {
        headline = __("All %s development licenses are allocated", productName);
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-license-upgrade-promo",
        style: {
            background: `linear-gradient(120deg, ${token.colorPrimary} 0%, ${COLOR_PRIMARY_DEEP} 50%, ${token.colorPrimary} 100%)`
        },
        children: [
            /*#__PURE__*/ _jsx(RocketOutlined, {
                className: "rc-account-v2-license-upgrade-promo__icon",
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-license-upgrade-promo__text",
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        className: "rc-account-v2-license-upgrade-promo__title",
                        children: headline
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "rc-account-v2-license-upgrade-promo__body",
                        children: __("Upgrade your plan to use the plugin on more websites - you only pay the difference until your next renewal.")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                icon: /*#__PURE__*/ _jsx(ArrowUpOutlined, {}),
                onClick: onUpgradeClick,
                className: "rc-account-v2-license-upgrade-promo__cta",
                style: {
                    color: token.colorPrimary
                },
                children: __("Upgrade plan")
            })
        ]
    });
};
export { LicenseAllocationUpgradePromo };
